import { AnimationEventHandler, useState } from 'react'
import { BlinkingRobot, Container, Spinners } from './YesLoading.styles'
import { YesLoadingProps } from './YesLoading.types'
import SpinnerSVG from './assets/spinner.svg'

export default function YesLoading({
  size = 120,
  durationMs = 1500,
  ...htmlProps
}: YesLoadingProps) {
  const [isSpinnerTurn, setIsSpinnerTurn] = useState(true)

  const toggleAnimatedElement: AnimationEventHandler = (e) => {
    if (e.target === e.currentTarget) {
      setIsSpinnerTurn((previous) => !previous)
    }
  }

  return (
    <Container role='presentation' size={size} {...htmlProps}>
      <Spinners
        animating={isSpinnerTurn}
        animationDurationMs={durationMs}
        onAnimationEnd={toggleAnimatedElement}
      >
        <SpinnerSVG />
      </Spinners>
      <BlinkingRobot
        $animating={!isSpinnerTurn}
        $animationDurationMs={durationMs}
        onAnimationEnd={toggleAnimatedElement}
      />
    </Container>
  )
}
